export default function Lock() {
  let unlocked = false
  let callbacks = []

  return [unlock, onceUnlocks]

  function unlock() {
    unlocked = true

    for (const callback of callbacks) {
      callback()
    }

    callbacks = []
  }

  function onceUnlocks(callback) {
    if (unlocked) {
      callback()
    } else {
      callbacks.push(callback)
    }
  }
}
